import { computed, unref } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import fetchData from '@/util/fetch'

// The tickets of an address (search on the full address), shared by the tickets tab and its count
// in the tab header: same query key, so one request.
export function useAddressTickets(address) {
  return useQuery({
    queryKey: computed(() => ['tickets', unref(address)]),
    queryFn: async () => {
      const params = new URLSearchParams({ view: 'list', query: unref(address) })
      const result = await fetchData(`/tickets/api/v1/tickets?${params}`)
      return result.data
    },
    enabled: computed(() => !!unref(address)),
  })
}
